<template>
  <footer class="footer">
    <div class="container">
      <r-grid columns="7" columns-s="1">
        <r-cell span="2" span-s="row">
          <h3>Links</h3>
          <MenuLinks />
        </r-cell>
        <r-cell span="2" span-s="row">
          <h3>Follow us</h3>
          <a
            @click="openSocialProfile('https://www.facebook.com/wheretomeat')"
            style="cursor:pointer;"
          >
            <i class="fab fa-facebook-square fa-2x white"></i>
          </a>
          <a
            @click="openSocialProfile('https://twitter.com/WhereToMeat')"
            class="ml-16"
            style="cursor:pointer;"
          >
            <i class="fab fa-twitter-square fa-2x white"></i>
          </a>
          <a
            @click="
              openSocialProfile('https://www.instagram.com/where_to_meat/')
            "
            class="ml-16"
            style="cursor:pointer;"
          >
            <i class="fab fa-instagram fa-2x white"></i>
          </a>
        </r-cell>
        <r-cell span="3" span-s="row">
          <div id="newsletter" class="newsletter">
            <h3 class="white">Be in the know</h3>
            <div id="mc_embed_signup mb-16">
              <form
                action="https://wheretomeat.us4.list-manage.com/subscribe/post?u=6e0361d0bf2ffa05245ad4b15&amp;id=ed40155629"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate=""
              >
                <div id="mc_embed_signup_scroll">
                  <div class="mc-field-group">
                    <label for="mce-EMAIL"
                      ><strong>Email address</strong>
                    </label>
                    <input
                      type="email"
                      class="f-left mr-16 mb-16"
                      value=""
                      name="EMAIL"
                      id="mce-EMAIL"
                      placeholder="Enter email address"
                    />
                  </div>
                  <div id="mce-responses">
                    <div
                      class="response"
                      id="mce-error-response"
                      style="display:none"
                    ></div>
                    <div
                      class="response"
                      id="mce-success-response"
                      style="display:none"
                    ></div>
                  </div>
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px;"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_6e0361d0bf2ffa05245ad4b15_ed40155629"
                      tabindex="-1"
                      value=""
                    />
                  </div>
                  <div>
                    <input
                      type="submit"
                      value="Subscribe"
                      @click="
                        trackEvent('click_subscribe', 'newsletter', 'footer')
                      "
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      class="mb-16 f-left button btn btn-fill"
                    />
                  </div>
                </div>
                <!-- <p class="clear font-small meta pt-16">or <a href="mailto:wheretomeatuk@gmail.com">send us an email</a> if you have any questions.</p> -->
              </form>
            </div>
            <p class="clear meta font-small">
              You will receive occasional updates from us. Your details will be
              stored in accordance with data protection legislation and we
              promise not to share your details with anyone else.
            </p>
          </div>
        </r-cell>
        <r-cell span="7" span-s="row">
          <hr class="hr slate-bg" />
          <p class="font-small meta f-right mt-4">Where To Meat © 2020</p>
          <a href="#" class="logo logo-white f-left">
            <svg
              width="139"
              height="22"
              viewBox="0 0 139 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.7784 16H28.0455L29.5284 11.125H29.5966L31.0795 16H33.3466L35.9205 7.27273H33.2784L32.0852 12.6591H32.017L30.6023 7.27273H28.5227L27.108 12.642H27.0398L25.8466 7.27273H23.2045L25.7784 16ZM38.349 16H40.7184V12.5909H43.8547V16H46.224V7.27273H43.8547V10.6818H40.7184V7.27273H38.349V16ZM49.0106 16H55.2833V14.0909H51.3799V12.5909H54.9765V10.6818H51.3799V9.18182H55.3003V7.27273H49.0106V16ZM58.137 16H60.5063V13.1193H61.3245L62.8586 16H65.4324L63.6597 12.7443C64.5887 12.2969 65.1426 11.4489 65.1426 10.2386C65.1426 8.38068 63.8429 7.27273 61.904 7.27273H58.137V16ZM60.5063 11.2784V9.16477H61.3415C62.1725 9.16477 62.6711 9.48864 62.6711 10.2386C62.6711 10.9844 62.1725 11.2784 61.3415 11.2784H60.5063ZM67.8141 16H74.0868V14.0909H70.1834V12.5909H73.78V10.6818H70.1834V9.18182H74.1039V7.27273H67.8141V16ZM76.9576 8.21023H79.7019V16H80.7587V8.21023H83.503V7.27273H76.9576V8.21023ZM93.7959 11.6364C93.7959 8.875 92.1766 7.15341 89.9437 7.15341C87.7107 7.15341 86.0914 8.875 86.0914 11.6364C86.0914 14.3977 87.7107 16.1193 89.9437 16.1193C92.1766 16.1193 93.7959 14.3977 93.7959 11.6364ZM92.7732 11.6364C92.7732 13.9034 91.5289 15.1307 89.9437 15.1307C88.3584 15.1307 87.1141 13.9034 87.1141 11.6364C87.1141 9.36932 88.3584 8.14205 89.9437 8.14205C91.5289 8.14205 92.7732 9.36932 92.7732 11.6364ZM96.7401 7.27273V16H99.0583V10.9205H99.1265L101.07 15.9318H102.467L104.411 10.9545H104.479V16H106.797V7.27273H103.848L101.82 12.2159H101.717L99.689 7.27273H96.7401ZM109.581 16H115.854V14.0909H111.951V12.5909H115.547V10.6818H111.951V9.18182H115.871V7.27273H109.581V16ZM120.975 16L121.478 14.3295H124.358L124.861 16H127.418L124.537 7.27273H121.299L118.418 16H120.975ZM122.015 12.5568L122.884 9.67614H122.952L123.821 12.5568H122.015ZM128.568 9.18182H131.193V16H133.528V9.18182H136.153V7.27273H128.568V9.18182Z"
                fill="white"
              />
              <mask
                id="path-2-outside-1"
                maskUnits="userSpaceOnUse"
                x="0.704779"
                y="-1.16758"
                width="20.8127"
                height="23.1135"
                fill="black"
              >
                <rect
                  fill="white"
                  x="0.704779"
                  y="-1.16758"
                  width="20.8127"
                  height="23.1135"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.591 15.1755C12.9769 16.8142 13.3262 18.2981 12.4677 18.8508C11.379 19.5516 5.63598 8.05158 7.33182 4.93362C8.0661 3.02076 10.5463 2.13879 12.5654 2.91385C14.48 3.6488 15.0866 5.52921 14.5888 7.17215C14.3224 8.05745 13.9229 8.89647 13.4024 9.66342C12.6014 10.8048 12.0509 12.5681 12.2953 13.8388C12.3815 14.2855 12.4875 14.7361 12.591 15.1755ZM9.16521 5.38225C9.56106 4.35105 10.768 3.85523 11.8611 4.2748C12.9541 4.69438 13.5193 5.87047 13.1235 6.90168C12.7276 7.93288 11.5206 8.4287 10.4276 8.00913C9.33456 7.58955 8.76937 6.41345 9.16521 5.38225ZM10.2108 5.66367C10.4087 5.14807 10.9871 4.89053 11.5027 5.08846C12.0183 5.28638 12.2758 5.8648 12.0779 6.3804C11.88 6.89601 11.3016 7.15354 10.786 6.95562C10.2704 6.7577 10.0128 6.17927 10.2108 5.66367Z"
                />
              </mask>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.591 15.1755C12.9769 16.8142 13.3262 18.2981 12.4677 18.8508C11.379 19.5516 5.63598 8.05158 7.33182 4.93362C8.0661 3.02076 10.5463 2.13879 12.5654 2.91385C14.48 3.6488 15.0866 5.52921 14.5888 7.17215C14.3224 8.05745 13.9229 8.89647 13.4024 9.66342C12.6014 10.8048 12.0509 12.5681 12.2953 13.8388C12.3815 14.2855 12.4875 14.7361 12.591 15.1755ZM9.16521 5.38225C9.56106 4.35105 10.768 3.85523 11.8611 4.2748C12.9541 4.69438 13.5193 5.87047 13.1235 6.90168C12.7276 7.93288 11.5206 8.4287 10.4276 8.00913C9.33456 7.58955 8.76937 6.41345 9.16521 5.38225ZM10.2108 5.66367C10.4087 5.14807 10.9871 4.89053 11.5027 5.08846C12.0183 5.28638 12.2758 5.8648 12.0779 6.3804C11.88 6.89601 11.3016 7.15354 10.786 6.95562C10.2704 6.7577 10.0128 6.17927 10.2108 5.66367Z"
                fill="#BF2A2A"
              />
              <path
                d="M12.4677 18.8508L11.3852 17.169L12.4677 18.8508ZM12.591 15.1755L14.5378 14.7172L14.5378 14.7172L12.591 15.1755ZM7.33182 4.93362L9.08876 5.88921L9.15174 5.77341L9.19898 5.65036L7.33182 4.93362ZM14.5888 7.17215L12.6747 6.59217L12.6736 6.59595L14.5888 7.17215ZM13.4024 9.66342L15.0395 10.8123L15.0485 10.7995L15.0573 10.7865L13.4024 9.66342ZM12.2953 13.8388L10.3314 14.2167L10.3315 14.2174L12.2953 13.8388ZM13.5502 20.5325C14.9164 19.6531 15.0305 18.1631 14.9941 17.3329C14.9558 16.4593 14.716 15.4743 14.5378 14.7172L10.6442 15.6339C10.7427 16.052 10.8273 16.4126 10.8921 16.7455C10.9572 17.0802 10.99 17.3272 10.9979 17.508C11.0063 17.6992 10.9814 17.7143 11.0087 17.6334C11.0502 17.5108 11.1658 17.3103 11.3852 17.169L13.5502 20.5325ZM5.57487 3.97803C5.14058 4.77653 5.02495 5.67165 5.02098 6.44531C5.01688 7.24503 5.13238 8.09668 5.30866 8.93409C5.6615 10.6103 6.30541 12.4489 7.01689 14.1112C7.72886 15.7746 8.54646 17.3497 9.28804 18.4964C9.64815 19.0533 10.0489 19.6014 10.463 20.0083C10.6586 20.2005 10.9694 20.4748 11.3788 20.6624C11.7942 20.8527 12.6736 21.0968 13.5502 20.5325L11.3852 17.169C12.1257 16.6924 12.8327 16.9287 13.0452 17.026C13.2516 17.1206 13.3291 17.2166 13.2668 17.1554C13.165 17.0554 12.9517 16.7957 12.6468 16.3242C12.0584 15.4143 11.3421 14.051 10.6942 12.5373C10.0458 11.0224 9.50392 9.44525 9.22288 8.11014C9.08221 7.44191 9.01876 6.88907 9.02093 6.46582C9.02323 6.01652 9.0991 5.8702 9.08876 5.88921L5.57487 3.97803ZM13.2821 1.04669C10.4458 -0.0420578 6.67222 1.07109 5.46466 4.21689L9.19898 5.65036C9.45998 4.97043 10.6468 4.31964 11.8487 4.78101L13.2821 1.04669ZM16.5028 7.75212C17.2502 5.2856 16.3418 2.2212 13.2821 1.04669L11.8487 4.78101C12.3064 4.9567 12.5293 5.22398 12.6433 5.49011C12.77 5.78577 12.7999 6.179 12.6747 6.59217L16.5028 7.75212ZM15.0573 10.7865C15.6915 9.85194 16.179 8.82859 16.504 7.74834L12.6736 6.59595C12.4659 7.28631 12.1542 7.941 11.7475 8.54037L15.0573 10.7865ZM14.2593 13.461C14.2149 13.2302 14.2264 12.802 14.3832 12.2403C14.5349 11.6966 14.7808 11.1809 15.0395 10.8123L11.7653 8.51453C11.2229 9.28737 10.7931 10.224 10.5304 11.165C10.2728 12.088 10.1313 13.1768 10.3314 14.2167L14.2593 13.461ZM14.5378 14.7172C14.4327 14.2708 14.3363 13.8601 14.2592 13.4602L10.3315 14.2174C10.4266 14.711 10.5424 15.2014 10.6443 15.6339L14.5378 14.7172ZM12.5778 2.40764C10.5575 1.63212 8.12849 2.50215 7.29805 4.66551L11.0324 6.09899C11.0275 6.11171 11.0188 6.12461 11.0103 6.13303C11.0032 6.14008 11.0021 6.1384 11.0117 6.13447C11.0316 6.1263 11.0783 6.11662 11.1443 6.14196L12.5778 2.40764ZM14.9906 7.61842C15.8211 5.45505 14.5981 3.18317 12.5778 2.40764L11.1443 6.14196C11.2104 6.16731 11.2386 6.20579 11.248 6.22517C11.2524 6.2345 11.2505 6.235 11.2499 6.22502C11.2493 6.2131 11.2514 6.19766 11.2563 6.18494L14.9906 7.61842ZM9.71087 9.87629C11.7312 10.6518 14.1602 9.78178 14.9906 7.61842L11.2563 6.18494C11.2612 6.17222 11.2699 6.15932 11.2784 6.1509C11.2855 6.14385 11.2866 6.14553 11.277 6.14946C11.2571 6.15763 11.2104 6.16731 11.1443 6.14196L9.71087 9.87629ZM7.29805 4.66551C6.46762 6.82888 7.69056 9.10076 9.71087 9.87629L11.1443 6.14196C11.0783 6.11662 11.05 6.07814 11.0407 6.05876C11.0362 6.04943 11.0382 6.04893 11.0387 6.05891C11.0394 6.07083 11.0373 6.08627 11.0324 6.09899L7.29805 4.66551ZM12.2194 3.2213C10.6726 2.62753 8.93736 3.40013 8.3436 4.94693L12.0779 6.3804C11.88 6.89601 11.3016 7.15354 10.786 6.95562L12.2194 3.2213ZM13.9451 7.09714C14.5388 5.55033 13.7662 3.81506 12.2194 3.2213L10.786 6.95562C10.2704 6.7577 10.0128 6.17927 10.2108 5.66367L13.9451 7.09714ZM10.0692 8.82278C11.616 9.41654 13.3513 8.64395 13.9451 7.09714L10.2108 5.66367C10.4087 5.14807 10.9871 4.89053 11.5027 5.08846L10.0692 8.82278ZM8.3436 4.94693C7.74983 6.49374 8.52243 8.22901 10.0692 8.82278L11.5027 5.08846C12.0183 5.28638 12.2758 5.8648 12.0779 6.3804L8.3436 4.94693Z"
                fill="white"
                mask="url(#path-2-outside-1)"
              />
            </svg>
          </a>
        </r-cell>
      </r-grid>
    </div>
    <cookie-law />
  </footer>
</template>

<script>
import MenuLinks from "../../components/content/MenuLinks";
import CookieLaw from "../../components/content/CookieLaw";

export default {
  name: "Footer",
  components: {
    MenuLinks,
    CookieLaw
  },
  methods: {
    trackEvent(action, category, label) {
      // label is optional
      if (label) {
        this.$gtag.event(action, {
          event_category: category,
          event_label: label
        });
      } else {
        this.$gtag.event(action, {
          event_category: category
        });
      }
    },
    openSocialProfile(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss">
@import "@/global-styles/variables.scss";

.footer {
  background: $black;
  color: $white;
  display: block;
  overflow: hidden;

  footer {
    padding: 0;
  }

  h3 {
    color: $slate;

    &.black {
      color: $black;
    }
  }

  .menu-links {
    display: inline;

    li {
      &:last-of-type {
        display: none;
      }
    }

    a {
      color: #fff;
      padding: $spacing-2 0;
    }
  }
}
</style>
